import { useMutation } from '@tanstack/react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { createTCRBrandAndCampaign } from 'services';
import { useSnackbar } from 'hooks';

export function useCreateTCRBrandAndCampaign() {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;

  const errorMessage =
    'Something went wrong while create the TCR campaign, please try again later.';
  const setSnackbar = useSnackbar();

  return useMutation({
    mutationFn: () => createTCRBrandAndCampaign(corpAcctNbr),
    onError: (error) => {
      const errorResponse = error as {
        response?: { data?: { displayMessage?: string } };
      };
      setSnackbar({
        message: errorResponse?.response?.data?.displayMessage || errorMessage,
        severity: 'error',
      });
    },
  });
}
